__webpack_require__.p = "/VeggieVitals/";